// extracted by mini-css-extract-plugin
module.exports = {"container":"user-avatar_container__35vNb","notifMarker":"user-avatar_notifMarker__23LP0","image":"user-avatar_image__2beNt","icon":"user-avatar_icon__3of7G"};